var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"visible-menu"}},[_c('div',{staticClass:"main_menu"},_vm._l((_vm.option),function(el){return _c('div',{key:el},[_c('p',{attrs:{"id":el},on:{"click":_vm.clickButton}},[_vm._v("\n\t\t\t\t"+_vm._s(el)+"\n\t\t\t")])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0c44ea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = null
// module chunks = 